export const FORM_MODE = {
    INSERT : 'insert',
    UPDATE : 'update',
    DELETE : 'delete',
}

export const BANKS = [
    {name : '국민', code : 	'004'},
    {name : '신한', code :  '088'},
    {name : '하나', code : '081'},
    {name : '농협', code : 	'011'},
    {name : '우리', code : 	'020'},
    {name : '기업', code :  '003'},
    {name : '경남', code : 	'039'},
    {name : '광주', code :  '034'},
    {name : '대구', code :  '031'},
    {name : '우체국', code : '071'},
    {name : '부산', code :  '032'},
    {name : 'SC', code : '023'},
    {name : '제주', code :  '035'},
    {name : '새마을', code : '045'},
    {name : '수협', code :  '007'},
    {name : '신협', code : 	'048'},
    {name : '씨티', code : 	'027'},
    {name : '카카오뱅크', code : '090'},
    {name : '토스뱅크', code : '091'},
    {name : '케이뱅크', code : '089'},
    {name : '전북', code : 	'037'},
    {name : '상호저축', code : '050'},
    {name : '산업', code : 	'002'},
    {name : '산림조합중앙회', code : '064'},
    {name : '지역농축협', code : '012'},
    {name : '공상', code :  '062'},
    {name : 'BNP파리바', code : '061'},
    {name : 'JP모간', code : '057'},
    {name : 'BOA', code : '060'},
    {name : 'HSBC', code : '054'},
    {name : '구조흥', code : '021'},
    {name : '구신한', code : '026'},
    {name : '도이치', code : '055'},
    {name : '유안타증권', code : '209'},
    {name : 'KB증권', code : '218'},
    {name : '미래에셋증권', code : '230'},
    {name : '미래에셋대우', code : '238'},
    {name : '삼성증권', code : '240'},
    {name : '한국투자증권', code : '243'},
    {name : 'NH투자증권', code : '247'},
    {name : '하이투자증권', code : '262'},
    {name : '에이치엠씨투자증권', code : '263'},
    {name : '에스케이증권', code : '266'},
    {name : '한화증권', code : '269'},
    {name : '하나금융투자', code : '270'},
    {name : '신한금융투자', code : '278'},
    {name : '메리츠종합금융증권', code : '287'},
    {name : '유진투자증권', code : '280'},
    {name : '신영증권', code : '291'},
    {name : '교보증권', code : '261'},
    {name : '대신증권', code : '267'},
    {name : '동부증권', code : '279'},
    {name : '부곡증권', code : '290'},
    {name : '이베스트투자증권', code : '265'},
    {name : '솔로몬투자증권', code : '268'},
    {name : '케이프투자증권', code : '292'},
    {name : '키움증권', code : '264'},
    {name : '펀드온라인', code : '294'},
    {name : 'KTB투자증권', code : '227'},
]

